import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 49.29 49.29' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='general_content' data-name='general content'>
        <path
          className='cls-1'
          d='M24.64 0a24.64 24.64 0 1 0 24.65 24.64A24.64 24.64 0 0 0 24.64 0zm0 46.73a22.08 22.08 0 1 1 22.09-22.09 22.08 22.08 0 0 1-22.09 22.09z'
        />
        <path
          className='cls-1'
          d='M32.58 23.36h-6.66v-6.65a1.28 1.28 0 1 0-2.56 0v6.66h-6.65a1.28 1.28 0 1 0 0 2.56h6.66v6.66a1.28 1.28 0 1 0 2.56 0v-6.67h6.66a1.28 1.28 0 1 0 0-2.56z'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/AddCircleIcon.js